import '.bq{position:relative;}.ssr-plugin'
import '.w{width:100%;}.ssr-plugin'
import '.g0{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.n{justify-content:center;}.ssr-plugin'
import '.cd{align-items:flex-start;}.ssr-plugin'
import '.m{padding:2rem;}.ssr-plugin'
import '.cm{background:var(--shades-white);}.ssr-plugin'
import '.a3{overflow:hidden;}.ssr-plugin'
import '.z{position:absolute;}.ssr-plugin'
import '.ic{top:50%;}.ssr-plugin'
import '.id{right:1rem;}.ssr-plugin'
import '.ie{transform:translateY(-50%);}.ssr-plugin'
import '.if{width:120px;}.ssr-plugin'
import '.ig{height:120px;}.ssr-plugin'
import '.ih{z-index:0;}.ssr-plugin'
import '.e{align-items:center;}.ssr-plugin'
import '.hm{z-index:1;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import '.ii{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="bq w g0 a b n cd m cm a3"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="z ic id ie if ig ih a e n"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="bq hm a b cd al ii"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
